import { Component, ElementRef, EventEmitter, HostListener, Input, OnInit, Output } from '@angular/core';
import { NavigationEnd, Router } from '@angular/router';
import { Store } from '@ngrx/store';
import { Observable, Subscription, distinctUntilChanged, filter } from 'rxjs';
import { AppConfigService } from 'src/app/appconfig/appconfig.service';
import { Cart } from 'src/app/_models/cart';
import { Plan } from 'src/app/_models/plan';
import { PagesService } from 'src/app/_services/pages.service';
import brandInfo from "src/environments/brand.json";
import { clear } from 'src/app/_actions/modal-component.actions'
import { Vehicle } from 'src/app/_models/vehicle';
import { OktaSignOutRequest, OktaUser } from 'src/app/_models/okta';
import { oktaSignOut, resetOktaUser } from 'src/app/_actions/okta.actions';
import { Lead } from 'src/app/_models/lead';
import { TranslateService } from '@ngx-translate/core';
import { resetDealer, validateDealerSuccess } from 'src/app/_actions/dealer-actions';
import { clearCart } from 'src/app/_actions/cart.actions';
import { AccountResponse } from 'src/app/_models/account';
import { RateData } from 'src/app/_models/rates';
import { resetRates } from 'src/app/_actions/rates.actions';
import { removeVehicle } from 'src/app/_actions/vehicle.actions';
import { hideInlineLoader } from 'src/app/_actions/inline-loader.actions';
import { resetPrismic } from 'src/app/_actions/prismic.actions';
import { account, guest, sdLogout } from 'src/app/_actions/app-flow-state.actions';
import { MDBModalService } from 'ng-uikit-pro-standard';
import { ModalInfoComponent } from 'src/app/modal-info/modal-info.component';
import { isServiceDriveOnlyFromHeader } from 'src/app/_helpers/service-drive-only';

import { RouterModule } from "@angular/router";
import { TranslateModule } from "@ngx-translate/core";
import { MDBBootstrapModulesPro } from "ng-uikit-pro-standard";
import { CloseButtonComponent } from "../../close-button/close-button.component";
import { CommonModule } from "@angular/common";

@Component({
  selector: "app-desktop-nav",
  standalone: true,
  templateUrl: "./desktop-nav.component.html",
  styleUrls: ["./desktop-nav.component.scss"],
  imports: [CommonModule, RouterModule, TranslateModule, MDBBootstrapModulesPro, CloseButtonComponent]
})
export class DesktopNavComponent implements OnInit {
  @Input() logo: any;
  @Input() navLinks: any;
  @Input() productLinks: any;

  @Input() isLogin: boolean;
  public cartCount = 0;
  cartSubscription: Subscription;
  @Output("callbackSignOut") callbackSignOut: EventEmitter<any> = new EventEmitter();
  @Output("showCart") showCart: EventEmitter<any> = new EventEmitter();
  public cart$: Observable<Cart>;
  public lead$: Observable<Lead>;
  branding: any;
  brandInfo: any;
  isCheckoutPage: boolean;
  useProductSubmenuNav = false;
  isCartPage = false;
  isHelpPage = false;
  currentProductLink = "";
  dealerName = null;
  oktaUserSub: Subscription;
  oktaId: any;
  login: any;
  access_token: any;
  product1: string;
  product2: string;
  products: string;
  currentURL: string;
  compareProduct: string;
  dealer: any;
  dealerSub: Subscription;
  showSDLogout = false;
  dealerAgent = "";
  showPhoneNumber: boolean;
  showMobile: boolean;
  customer = '';
  showSubmenuICE = false;
  showSubmenuEV = false;
  showSubmenuTW = false;
  hasVehicle = false;
  accountSub: Subscription;
  productArray = [];

  private extractDealerNameFromLead(lead: any): string {
    const source = lead?.payload ?? lead;
    if (!source) {
      return "";
    }

    return (
      source?.dealerStatus?.dealershipName ||
      source?.dealerStatus?.dealerGroupName ||
      source?.dealerGroupName ||
      source?.dealerName ||
      source?.dealershipName ||
      source?.dealership?.name ||
      source?.dealer?.name ||
      ""
    );
  }

  constructor(
    private translate: TranslateService,
    private router: Router,
    private appConfig: AppConfigService,
    private el: ElementRef,
    private modalService: MDBModalService,
    private store: Store<{
      cart: Cart;
      plan: Plan;
      oktaUser: any
      lead: Lead;
      dealer: any;
      vehicle: Vehicle;
      account: any;
      rates: any;
    }>,
    private pageService: PagesService
  ) {
    console.log("using language 2: ", this.translate.currentLang);
  }

  get helpLink(): string {
    return this.brandInfo?.brand === 'NCESI' ? '/help' : '/help-center';
  }

  /** True if URL is an in-app path (use routerLink); false for external URLs (use href). */
  isInternalLink(url: string): boolean {
    if (!url) return false;
    return !url.startsWith('http') && !url.startsWith('//');
  }

  ngOnInit(): void {
    console.log('productLinks', this.productLinks)
    this.brandInfo = brandInfo;
    this.useProductSubmenuNav = this.brandInfo.useProductSubmenuNav === true;

    this.store.select((store) => store.rates)
      .pipe(distinctUntilChanged())
      .subscribe((rates) => {
        if (rates && rates.data && rates.data.productDetailsList) {
          this.productArray = [];

          // Handle product-submenu nav menu logic (useProductSubmenuNav)
          if (this.brandInfo.useProductSubmenuNav) {
            this.showSubmenuICE = false;
            this.showSubmenuEV = false;
            this.showSubmenuTW = false;

            rates.data.productDetailsList.forEach((product) => {
              if (product.productCode.indexOf("POED") > -1 && product.message.indexOf("Success") > -1) {
                this.showSubmenuEV = true;
              }
              if (product.productCode.indexOf("POVD") > -1 && product.message.indexOf("Success") > -1) {
                this.showSubmenuICE = true;
              }
              if (product.productCode.indexOf("POSD") > -1 && product.message.indexOf("Success") > -1) {
                this.showSubmenuTW = true;
              }
            });
          } else {
            // Handle non-product-submenu nav brands
            rates.data.productDetailsList.forEach((product) => {
              if (product.message.indexOf("Success") > -1) {
                this.productArray.push(product.productCode);
              }
            });
          }
        }
      });

    this.lead$ = this.store.select((store) => store.lead);
    this.lead$
      .pipe(
        filter((lead) => lead !== null && lead !== undefined),
        distinctUntilChanged()
      )
      .subscribe((lead) => {
        const resolvedDealerName = this.extractDealerNameFromLead(lead);
        if (resolvedDealerName) {
          this.dealerName = resolvedDealerName;
        }
      })

    this.cart$ = this.store.select((store) => store.cart);
    this.cartSubscription = this.cart$.subscribe((cart) => {
      if (cart && cart.shoppingCartData.lineItems) {
        this.cartCount = cart.shoppingCartData.lineItems.length;
      } else {
        this.cartCount = 0;
      }
    });

    this.store.select((store) => store.vehicle).subscribe((vehicle) => {
      if (vehicle && vehicle.registeredState) {
        this.hasVehicle = true;
      } else {
        this.hasVehicle = false;
      }
    });

    this.appConfig.getSettings().subscribe((result) => {
      this.branding = result;
    });

    this.accountSub = this.store.select(store => store.account).subscribe(data => {
      if (data && data.data) {
        this.customer = data.data[0].customer.firstName + " " + data.data[0].customer.lastName.split('')[0] + ".";
      }
    })


    this.oktaUserSub = this.store.select(store => store.oktaUser).subscribe(data => {
      if (data !== null && data !== false) {
        this.oktaId = data.id
        this.login = data.login
        this.access_token = data.access_token
      } else if (data === false) {
        this.callbackSignOut.emit();
        this.store.dispatch(resetOktaUser())
      }
    })

    this.dealerSub = this.store.select(store => store.dealer).subscribe(data => {
      setTimeout(() => {
        const appFlowState = sessionStorage.getItem('appFlowState');
        // Check for SDLogout state first - show service drive products even without dealer data
        if (appFlowState === 'SDLogout') {
          this.showSDLogout = true;
          this.dealerName = "";
          this.dealerAgent = "";
        } else if (appFlowState && appFlowState.includes('serviceDrive') && data?.data) {
          if (!data.data.isPreview || data.data.isPreview === false) {
            this.dealerName = data.data.name;
          }
          if (brandInfo.brand === "Schomp") {
            this.dealerAgent = "Logout " + data.data.employeeId + "";
            this.showSDLogout = true;
          } else if (brandInfo.brand === "VCIVW") {
            if (data.data.employeeLastName === '') {
              this.showSDLogout = false;
            } else {
              let name = " " + data.data.employeeLastName ? data.data.employeeFirstName + " " + data.data.employeeLastName.split('')[0] + "." : '';
              this.dealerAgent = "Logout " + name + "";
              this.showSDLogout = true;
            }
          } else {
            let name = " " + data.data.employeeLastName ? data.data.employeeFirstName + " " + data.data.employeeLastName.split('')[0] + "." : '';
            this.dealerAgent = "Logout " + name + "";
            this.showSDLogout = true;
          }
        } else {
          // Keep lead-based dealer name (OID/account) when service-drive dealer data is absent.
          this.showSDLogout = false;
          this.dealerAgent = "";
        }
      }, 100);
    })

    this.router.events.pipe(filter((event) => event instanceof NavigationEnd)).subscribe((event: NavigationEnd) => {
      this.currentURL = event.url;
      if (event.url === "/checkout") {
        this.isCheckoutPage = true;
      } else {
        this.isCheckoutPage = false;
      }
      if (event.url === "/cart") {
        this.isCartPage = true;
      } else {
        this.isCartPage = false;
      }
      if (event.url === "/help" || event.url === "/help-center") {
        this.isHelpPage = true;
      } else {
        this.isHelpPage = false;
      }


      // Reset Porsche menus when navigating to service-drive
      // if (event.url === "/service-drive" && brandInfo.brand === "Porsche") {
      //   this.showSubmenuICE = false;
      //   this.showSubmenuEV = false;
      //   this.showSubmenuTW = false;
      // }
      // Nissan specific drop down menu text
      if (brandInfo.brand === "NCESI") {
        setTimeout(() => {
          this.translate.get("NAV").subscribe(nav => {
            this.product1 = nav.PRODUCT1;
            this.product2 = nav.PRODUCT2;
            this.products = nav.SHOP;

            this.compareProduct = nav.SHOP;

            if (this.currentURL.includes("/added-security-plan")) {
              this.currentProductLink = this.product1;
            } else if (this.currentURL.includes("/prepaid-maintenance")) {
              this.currentProductLink = this.product2;
            } else {
              this.currentProductLink = this.products;
            }

          })
        }, 750);
      }
      this.closeNav();

    });

    let skipContent = document.querySelector("#skipContent") as HTMLElement;
    skipContent.addEventListener('click', this.skipContent.bind(this));
  }
  @HostListener("window:resize", ["$event"])
  onResize(event) {
    this.checkNav();
  }

  checkForPrduct(productKeys) {
    return productKeys ? this.productArray.some(product => productKeys.includes(product)) : false;
  }

  checkForSD(product: string) {
    let rates = JSON.parse(sessionStorage.getItem("rates"));
    if (rates && rates.data && rates.data.productDetailsList && product === "PPM") {
      return rates.data.productDetailsList.some(product => product.productCategory === "Prepaid Maintenance");
    }
    if (rates && rates.data && rates.data.productDetailsList && product === "VSC") {
      return rates.data.productDetailsList.some(product => product.productCategory === "Vehicle Service");
    }
    return false;
  }

  ngAfterViewInit() {
    setTimeout(() => {
      this.checkNav();
    });
  }

  checkNav() {
    const width = window.innerWidth;
    if (width < 900 || brandInfo.centerNav) {
      this.showMobile = true;
    } else {
      this.showMobile = false;
    }
    this.closeNav();

  }

  redirectTo(uri) {
    // Reset Modal State
    this.store.dispatch(clear());
    //this.pageService.redirectTo(uri);
    window.location.href = uri;
  }

  redirectToHome() {
    let _appFlowState = sessionStorage.getItem("appFlowState");
    const isServiceDriveOnly = isServiceDriveOnlyFromHeader(this.productLinks) === true;
    const hasServiceDriveProducts =
      !!brandInfo?.servicePPMUrl?.link || !!brandInfo?.serviceVSCUrl?.link || brandInfo.useProductSubmenuNav;

    // In SDLogout mode, logo should prompt "Exit Service Drive" first.
    // - Cancel: stay on current page
    // - Confirm: switch to guest flow and navigate to homepage
    if (_appFlowState === 'SDLogout') {
      // Ensure we don't show inline loader while modal is open
      this.store.dispatch(hideInlineLoader());

      const modalOptions = {
        backdrop: true,
        keyboard: true,
        focus: true,
        show: false,
        scroll: true,
        ignoreBackdropClick: true,
        class: "modal-dialog-centered",
        containerClass: "",
        animated: true,
        data: {
          title: "Exit Service Drive",
          content: "Are you sure you want to leave? You will be logged out and any items in your cart will be cleared.",
          decisionMode: true,
          confirmButtonText: "Yes, Leave",
          cancelButtonText: "Cancel",
        },
      };

      const modalRef = this.modalService.show(ModalInfoComponent, modalOptions);
      const actionSubscription = modalRef?.content?.action?.subscribe((action: string) => {
        if (action === "confirm") {
          modalRef.hide();
          // Clear cart and related data, then transition to guest state
          this.store.dispatch(clearCart());
          this.store.dispatch(resetRates());
          this.store.dispatch(removeVehicle());
          this.store.dispatch(resetDealer());
          this.store.dispatch(guest());
          actionSubscription.unsubscribe();
          // Navigate to homepage after leaving SDLogout mode
          this.router.navigate(['/']);
        } else if (action === "cancel") {
          modalRef.hide();
          // Ensure loader stays hidden when navigation is cancelled
          this.store.dispatch(hideInlineLoader());
          actionSubscription.unsubscribe();
          // Stay on current page
        }
      });

      return;
    }

    // ServiceDrive-only brands:
    // - When dealer is logged in (ServiceDrive mode), logo should go to products *if available*.
    // - When dealer is logged out, logo should go to homepage.
    if (isServiceDriveOnly && _appFlowState && _appFlowState.includes('serviceDrive')) {
      if (this.showSDLogout && hasServiceDriveProducts) {
        this.router.navigate(['/products']);
      } else {
        this.router.navigate(['/']);
      }
      return;
    }

    // Non-ServiceDrive-only brands: keep existing ServiceDrive "home" behavior.
    if (_appFlowState && (_appFlowState.includes('serviceDrive') || _appFlowState === 'SDLogout')) {
      if (brandInfo['servicePPMUrl'] || brandInfo['serviceVSCUrl'] || brandInfo.useProductSubmenuNav) {
        this.router.navigate(['/products']);
        return;
      }
    }
    // Only clear session storage when in ServiceDrive appflow; preserve it for guest/account
    if (_appFlowState && (_appFlowState.includes('serviceDrive') || _appFlowState === 'SDLogout')) {
      this.resetSession();
    }
    this.store.dispatch(clear());
    this.store.dispatch(resetPrismic());

    if (!brandInfo.useProductSubmenuNav) {
      this.store.dispatch(resetDealer())
    }

    if (!brandInfo.useProductSubmenuNav) {
      this.store.dispatch(guest())
    }

    let _vehicle: Vehicle = JSON.parse(sessionStorage.getItem("vehicle"));
    const homePath = _vehicle && _vehicle.isElectric ? brandInfo.homePageElectric : brandInfo.homePage;
    this.pageService.redirectTo(`/${homePath}`);
  }

  goToHelp() {
    if (brandInfo.brand == 'NCESI') {
      this.pageService.redirectTo('/help');
    } else {
      this.pageService.redirectTo('/help-center');
    }
  }

  cartModalShow() {
    // this.cartSubscription.unsubscribe();

    //check is current page is /cart
    if (this.currentURL.indexOf("/cart") === -1) {
      this.showCart.emit();
    }
  }

  signOut(): void {
    let object: OktaUser = {
      id: this.oktaId,
      login: this.login,
      access_token: this.access_token
    }
    this.store.dispatch(resetOktaUser())
    this.store.dispatch(oktaSignOut(object))
    sessionStorage.clear()
  }

  logoutDealerAgent(): void {
    const isServiceDriveOnly = isServiceDriveOnlyFromHeader(this.productLinks) === true;

    // ServiceDrive-only brands should not enter SDLogout mode because there is no guest flow.
    // Schomp has both guest/account and Service Drive flow (like BMW/MINI), so it must use SDLogout.
    // Instead, clear state and return to the Service Drive login experience.
    if (isServiceDriveOnly && brandInfo.brand !== 'Schomp') {
      if (brandInfo.brand === 'VCIVW') {
        const _dealer = JSON.parse(sessionStorage.getItem('dealer'))
        _dealer.data.employeeFirstName = ''
        _dealer.data.employeeLastName = ''
        this.store.dispatch(validateDealerSuccess(_dealer))
        this.store.dispatch(removeVehicle());
        sessionStorage.removeItem('vehicle');
      } else {
        this.store.dispatch(validateDealerSuccess({}))
        this.store.dispatch(clearCart());
        this.store.dispatch(resetRates());
        this.store.dispatch(removeVehicle());
        sessionStorage.removeItem('vehicle');
      }
      // Ensure we don't persist SDLogout state
      if (sessionStorage.getItem('appFlowState') === 'SDLogout') {
        sessionStorage.setItem('appFlowState', 'serviceDrive');
      }
      window.location.href = "/service-drive";
      return;
    }

    if (brandInfo.brand === 'VCIVW') {
      const _dealer = JSON.parse(sessionStorage.getItem('dealer'))
      _dealer.data.employeeFirstName = ''
      _dealer.data.employeeLastName = ''
      this.store.dispatch(validateDealerSuccess(_dealer))
      this.store.dispatch(removeVehicle());
      sessionStorage.removeItem('vehicle');
      // Enter SDLogout mode after dealer logout (VCIVW) to keep Service Drive UX consistent
      // Set sessionStorage directly so SDLogout is preserved across the hard refresh.
      sessionStorage.setItem('appFlowState', 'SDLogout');
      this.store.dispatch(clearCart());
      this.store.dispatch(resetRates());
      this.store.dispatch(sdLogout());
      // Redirect to service-drive route while maintaining SDLogout state
      window.location.href = "/service-drive";
    } else {
      this.store.dispatch(validateDealerSuccess({}))
      this.store.dispatch(clearCart());
      this.store.dispatch(resetRates());
      this.store.dispatch(removeVehicle());
      sessionStorage.removeItem('vehicle');
      // Set sessionStorage directly so SDLogout is preserved across the hard refresh.
      sessionStorage.setItem('appFlowState', 'SDLogout');
      this.store.dispatch(sdLogout())
      // Redirect to service-drive route while maintaining SDLogout state
      // The SDLogout state is saved in sessionStorage and will be rehydrated on page load
      window.location.href = "/service-drive";
    }
  }

  navigateWithRefresh(route: string) {
    window.location.href = route;
  }

  shouldShowLogoutLink(): boolean {
    const appFlowState = sessionStorage.getItem('appFlowState');
    // Hide logout link in SDLogout mode (user is already logged out)
    return this.showSDLogout && appFlowState !== 'SDLogout';
  }


  openNav() {
    document.getElementById("mySidenav").style.display = "block";
    setTimeout(() => {
      if (brandInfo.centerNav && brandInfo.leftAlignNav) {
        document.getElementById("mySidenav").style.marginLeft = "0";
      } else {
        document.getElementById("mySidenav").style.marginRight = "0";
      }
      // Add click listener when sidenav is opened
      this.addClickOutsideListener();
    }, 0);
  }

  private addClickOutsideListener() {
    // Add click event listener to document
    document.addEventListener('click', this.handleClickOutside);
  }

  private handleClickOutside = (event: MouseEvent) => {
    const sidenav = document.getElementById("mySidenav");
    // Check if click is outside the sidenav
    if (sidenav && !sidenav.contains(event.target as Node)) {
      this.closeNav();
      // Remove the event listener
      document.removeEventListener('click', this.handleClickOutside);
    }
  }

  closeNav() {
    if (brandInfo.centerNav && brandInfo.leftAlignNav) {
      document.getElementById("mySidenav").style.marginLeft = "-300px";
    } else {
      document.getElementById("mySidenav").style.marginRight = "-300px";
    }
    setTimeout(() => {
      document.getElementById("mySidenav").style.display = "none";
      // Remove click listener when sidenav is closed
      document.removeEventListener('click', this.handleClickOutside);
    }, 400);
  }

  setCallUs(phone) {
    return this.translate.instant("NAV.CALL_US") + ' - ' + phone;
  }

  skipContent(e) {
    e.preventDefault();
    let maincontent = document.querySelector("#mainContent") as HTMLElement;
    maincontent.scrollIntoView();
    let mainDiv = document.querySelector("router-outlet").nextSibling as HTMLElement; // Only look for the first H1, H2 or H3 in the main page section which is after router-outlet
    let firstContent = mainDiv.querySelector("h1:not(.sr-ignore)") as HTMLElement; // Look for H1s first - All pages should have an H1 or H2 in the main section
    let firstContentOther = mainDiv.querySelector("div[aria-level='1']") as HTMLElement;
    if (firstContentOther) { firstContent = firstContentOther };
    if (firstContent) {
      let ti = firstContent.closest("[tabindex]") as HTMLElement;
      if (ti) {
        ti.focus();
      }
    } else {
      firstContent = mainDiv.querySelector("h2:not(.sr-ignore)") as HTMLElement; // Look for H2s second - All pages should have an H1 or H2 in the main section
      if (firstContent) {
        let ti = firstContent.closest("[tabindex]") as HTMLElement;
        if (ti) {
          ti.focus();
        }
      } else {
        firstContent = mainDiv.querySelector("h3:not(.sr-ignore)") as HTMLElement; // Look for H3s last - in case there is no H1 or H2
        if (firstContent) {
          let ti = firstContent.closest("[tabindex]") as HTMLElement;
          if (ti) {
            ti.focus();
          }
        }
      }
    }
  }

  resetSession() {
    if (!brandInfo.useProductSubmenuNav) {
      // Preserve specific keys while clearing the rest
      const keysToPreserve = ['appFlowState', 'correlationId', 'lpTabId', 'pagesFlow', 'prismicEnv', 'robots', 'stickyHeader', 'urlParams','vehicle'];
      const preservedData: { [key: string]: string } = {};

      // Store the values we want to keep
      keysToPreserve.forEach(key => {
        const value = sessionStorage.getItem(key);
        if (value !== null) {
          preservedData[key] = value;
        }
      });

      // Clear all session storage
      sessionStorage.clear();

      // Restore the preserved keys
      Object.keys(preservedData).forEach(key => {
        sessionStorage.setItem(key, preservedData[key]);
      });

      this.store.dispatch(clearCart());
      this.store.dispatch(resetRates());
      //this.store.dispatch(removeVehicle());
      //this.store.dispatch(resetDealer());
    } else {
      this.store.dispatch(clearCart())
      this.store.dispatch(resetRates())
      this.store.dispatch(removeVehicle())
    }

  }
}

// Change log for recent updates to this file:
// - Lines 314-316: Ensured nav is closed on resize by calling this.closeNav().
// - Lines 330-333: In redirectToHome, when in 'serviceDrive' and not Porsche, call this.resetSession() instead of redirecting to /products.
// - Lines 337-339: In redirectToHome, dispatch resetDealer() only for non-Porsche brands.
// - Lines 357-359: In redirectToHome, dispatch guest() only for non-Porsche brands.
// - Lines 488-518: In resetSession, added brand-specific handling:
//     - For non-Porsche: preserve selected sessionStorage keys, clear others, restore preserved keys, and reset cart/rates/vehicle/dealer.
//     - For Porsche: only clear cart, rates, and vehicle from the store.

